document.addEventListener('DOMContentLoaded', () => {
	const timelineHorizontals = document.querySelectorAll('.timeline-horizontal');

	function addEvenOddClasses() {
		timelineHorizontals.forEach((vertical, index) => {
			if (index % 2 === 0) {
				vertical.classList.add('even');
				vertical.classList.remove('odd');
			} else {
				vertical.classList.add('odd');
				vertical.classList.remove('even');
			}
		});
	}

	function updateClassesByViewport() {
		const isGreaterThan1024 = window.matchMedia('(min-width: 1024px)').matches;

		if (!isGreaterThan1024) {
			timelineHorizontals.forEach((vertical) => {
				vertical.classList.add('odd');
				vertical.classList.remove('even');
			});
		} else {
			addEvenOddClasses();
		}
	}

	window.addEventListener('resize', updateClassesByViewport);
	updateClassesByViewport();
});
